import styled from "@emotion/styled";
import { Box, BoxProps } from "@mui/material";

type ExtendedBoxProps = BoxProps & {
  radius?: number | string;
  padding?: number | string;
  margin?: number | string;
  boxShadow?: any;
  borderColor?: string;
  clipPath?: string;
  total?: boolean;
  url?: string;
  maxWidth?: number | string;
};

export const CustomizedBox = styled(Box)<ExtendedBoxProps>(
  ({
    padding,
    margin,
    radius,
    total,
    boxShadow,
    clipPath,
    borderColor,
    url,
    maxWidth,
  }) => ({
    border: `1px solid ${borderColor || "#d6cfcf"}`,
    borderRadius: radius || "14px",
    padding: padding ?? "1.5rem",
    margin: margin ?? "1.5rem 0rem",
    ...(total && {
      borderLeft: `5px ${
        borderColor ? borderColor : "rgba(72, 48, 222, 1) "
      } solid`,
    }),
    clipPath: clipPath,
    cursor: url ? "pointer" : "auto",
    maxWidth: maxWidth || "1040px",
  })
);
